import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Dropdown from './Dropdown';
import ChevronDown from '@/images/icons/ChevronDown';
import SignOut from '@/images/icons/SignOut';
import UserAvatar from './UserAvatar';
import CloseIcon from '@/images/icons/Close';
import { DropdownContext } from '@/components/Dropdown/DropdownContext';

function UserProfile({
  user,
}) {
  const { openDropdownId } = useContext(DropdownContext);
  const isDropdownOpen = openDropdownId === 'user-profile-dropdown';

  const userName = user.firstName + (user.lastName ? ' ' + user.lastName : '');

  const button = (
    <button
      className={classNames(
      "flex sm:inline-flex items-center group focus:outline-0 sm:p-2 rounded-[8px] transition",
        isDropdownOpen && 'sm:bg-[#F7F6F2]'
      )}
      aria-haspopup="true"
    >
      <UserAvatar className={classNames(
        'min-w-7 sm:min-w-8 w-7 sm:w-8 h-7 sm:h-8 rounded-full',
        isDropdownOpen && 'transition opacity-0 sm:opacity-100',
      )} user={user} />
      <div className={classNames(
        'sm:hidden flex absolute z-[1] inset-0 m-auto items-center justify-center rounded-full bg-[#F7F6F2] transition',
        isDropdownOpen ? 'opacity-100' : 'opacity-0',
      )}>
        <CloseIcon />
      </div>
      <div className="items-center truncate hidden sm:flex">
        <span className="md:max-w-[250px] truncate ml-2 mr-1 text-sm sm:text-base font-medium group-hover:text-slate-800">{userName}</span>
        <ChevronDown className={classNames(
          'w-4 h-4 ml-auto',
          isDropdownOpen && 'rotate-180',
        )} />
      </div>
    </button>
  );

  const itemStyle = "flex items-center p-4 text-white text-sm font-medium border-b border-b-[#313334] last:border-b-0 first:rounded-t-xl last:rounded-b-xl hover:bg-[#313334] transition";

  return (
    <div className="relative pl-3 ml-1 sm:ml-5 mr-1 sm:mr-0 flex before:hidden sm:before:content-[''] sm:before:block before:bg-[#E8E8E8] before:w-px before:h-auto before:absolute before:z-[1] before:m-auto before:top-2 before:bottom-2 before:-left-px">
      <Dropdown
        button={button}
        top="top-[calc(100%+16px)]"
        id="user-profile-dropdown"
      >
        <Link className={itemStyle} to="/account">
          Account
        </Link>
        <Link className={itemStyle} to="/manage-subscription">
          Billing
        </Link>
        <Link className={itemStyle} to="/logout">
          <SignOut className="w-4 h-4 mr-1" />
          Sign out
        </Link>
      </Dropdown>
    </div>
  )
}

export default UserProfile;
